<template>
  <div class="accordion">
    <component
      :is="tag"
      class="accordion__header"
      :disabled="disabled"
      @click="setActiveTabHash(hash)"
    >
      {{ title }}
      <i v-if="shouldShowArrow" :class="arrowIcon" />
    </component>
    <Transition
      name="expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div v-show="shouldOpen" class="accordion__body">
        <div class="accordion__body-inner">
          <slot />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "AccordionV2",
  inject: ["addTab", "activeTabHash", "setActiveTabHash", "mq"],
  props: {
    title: {
      type: String,
      required: true,
    },
    disableDesktop: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    openByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { hash: "", isActive: false };
  },
  computed: {
    arrowIcon() {
      return this.isActive ? "icon icon-arrow-up" : "icon icon-arrow-down";
    },
    tag() {
      if (this.disableDesktop && this.mq.mdPlus) {
        return "div";
      }

      return "button";
    },
    shouldShowArrow() {
      if (this.disableDesktop && this.mq.mdPlus) {
        return false;
      }

      return true;
    },
    shouldOpen() {
      if (this.disableDesktop && this.mq.mdPlus) {
        return true;
      }

      return this.isActive;
    },
  },
  watch: {
    activeTabHash() {
      this.isActive = this.activeTabHash === this.hash;
    },
  },
  created() {
    this.hash = "#" + this.title.toLowerCase().replace(/ /g, "-");

    this.addTab({
      title: this.title,
      hash: this.hash,
      isDefault: this.openByDefault,
    });
  },
  methods: {
    enter(element) {
      element.style.height = "0";

      requestAnimationFrame(() => {
        element.style.height = element.scrollHeight + "px";
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      element.style.height = element.scrollHeight + "px";

      requestAnimationFrame(() => {
        element.style.height = "0";
      });
    },
    afterLeave(element) {
      element.style.height = "auto";
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion:first-child .accordion__header {
  border-top: none;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 150ms ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
}

.accordion__header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  outline: none;
  border: none;
  border-top: 1px solid $color-grey-light;
  padding: 16px 0;
  @include utility-label(15px);
  text-align: left;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.accordion__body-inner {
  @include utility-body(15px);
  padding-top: 16px;
  padding-bottom: 40px;

  :deep(.wysiwyg) {
    @include utility-body(15px);
    margin-bottom: 0;

    p {
      @include utility-body(15px);
    }
  }
}

.accordion__arrow {
  font-size: 20px;
}
</style>
